import React from "react";
import { createPortal } from "react-dom";
import { AnimatePresence, motion } from "framer-motion";
import { Box, Button, CircularProgress, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

/** Barra flotante abajo mientras haya cambios sin guardar en la página (en modales no se usa). */
export default function UnsavedChangesBar({ count, saving, onDiscard, onSave }) {
  const theme = useTheme();
  const primary = theme.palette.primary.main;

  // En el body, para que ningún contenedor con transform u overflow de la página la tape.
  return createPortal(
    <AnimatePresence>
      {count > 0 ? (
        <motion.div
          initial={{ y: "150%" }}
          animate={{ y: 0 }}
          exit={{ y: "150%" }}
          transition={{ type: "spring", stiffness: 400, damping: 35 }}
          style={{
            position: "fixed",
            left: 0,
            right: 0,
            bottom: 16,
            zIndex: 1400,
            display: "flex",
            justifyContent: "center",
            padding: "0 16px",
            pointerEvents: "none",
          }}
        >
          <Box
            role="status"
            sx={{
              pointerEvents: "auto",
              width: "100%",
              maxWidth: 576,
              display: "flex",
              flexWrap: "wrap",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 1.5,
              px: 2,
              py: 1.5,
              borderRadius: 2,
              bgcolor: primary,
              color: "#fff",
              boxShadow: "0 12px 32px rgba(15, 23, 42, 0.22)",
            }}
          >
            <Typography component="span" sx={{ display: "flex", alignItems: "center", gap: 1, fontSize: 14, fontWeight: 500 }}>
              <Box component="span" sx={{ width: 6, height: 6, borderRadius: "50%", bgcolor: "#fff" }} />
              {count} {count === 1 ? "cambio sin guardar" : "cambios sin guardar"}
            </Typography>
            <Box sx={{ display: "flex", gap: 1 }}>
              <Button
                size="small"
                disabled={saving}
                onClick={() => onDiscard()}
                sx={{
                  textTransform: "none",
                  fontWeight: 600,
                  borderRadius: 999,
                  color: "#fff",
                  "&:hover": { bgcolor: "rgba(255,255,255,0.15)" },
                  "&.Mui-disabled": { color: "rgba(255,255,255,0.6)" },
                }}
              >
                Descartar
              </Button>
              <Button
                size="small"
                disabled={saving}
                onClick={() => onSave()}
                startIcon={saving ? <CircularProgress size={14} sx={{ color: primary }} /> : null}
                sx={{
                  textTransform: "none",
                  fontWeight: 600,
                  borderRadius: 999,
                  px: 2,
                  bgcolor: "#fff",
                  color: primary,
                  "&:hover": { bgcolor: "rgba(255,255,255,0.9)" },
                  "&.Mui-disabled": { bgcolor: "rgba(255,255,255,0.85)", color: primary },
                }}
              >
                Guardar cambios
              </Button>
            </Box>
          </Box>
        </motion.div>
      ) : null}
    </AnimatePresence>,
    document.body
  );
}
